import { WebPlugin } from '@capacitor/core';
export class FacebookAnalyticsWeb extends WebPlugin {
    constructor() {
        super({
            name: 'FacebookAnalytics',
            platforms: ['web'],
        });
    }
    logEvent(options) {
        // TODO: Implement.
        return Promise.resolve(options.event);
    }
    logPurchase(options) {
        // TODO: Implement.
        return Promise.resolve(JSON.stringify(options));
    }
    logAddPaymentInfo(options) {
        // TODO: Implement.
        return Promise.resolve(JSON.stringify(options));
    }
    logAddToCart(options) {
        // TODO: Implement.
        return Promise.resolve(JSON.stringify(options));
    }
    logCompleteRegistration(options) {
        // TODO: Implement.
        return Promise.resolve(JSON.stringify(options));
    }
    logInitiatedCheckout(options) {
        // TODO: Implement.
        return Promise.resolve(JSON.stringify(options));
    }
}
const FacebookAnalytics = new FacebookAnalyticsWeb();
export { FacebookAnalytics };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(FacebookAnalytics);
//# sourceMappingURL=web.js.map